import HeaderPage from '../../components/header_page';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../selectors/pages/main/balance';
import {redeemTask} from '../../../reducers/app/actions';
import {useNavigate} from 'react-router-dom';
import Timeout from './timeout';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Pagination} from 'swiper/modules'
import 'swiper/css';
import Levels from './levels';
import MyLevels from './my_levels';

export default () => {
    const {wallet} = useSelector(Selector),
          dispatch = useDispatch(),
          navigate = useNavigate();

    return (
        <>
            <HeaderPage title={"VIP Cashback"} />

            <div className="cashback">
                <div className="block">
                    <div className="cashback_amount">
                        <b>$ {wallet.cashback.balance.toFixed(2)}</b>
                        Cashback Amount
                    </div>
                    {wallet.cashback.balance == 0 ? (
                        <div className="claim active" onClick={e => navigate('/deposit')}>Deposit</div>
                    ) : (
                        <Timeout task_key={"main_cashback"} timeout={wallet.cashback.timestamp} short={false} activeClass={"claim active"} inactiveClass={"claim"} balance={wallet.cashback.balance} />
                    )}
                </div>

                {wallet.cashback.level === "bronze" && (
                    <div className="freeplay-status cashback">
                        <div className="top">
                            <div className="left">
                                <div className="icon">
                                    🤔
                                </div>

                                Have freezee redeem from free play?
                            </div>
                        </div>
                        <div className="bottom">
                            You can play free games, but you will not be able to withdraw funds to your wallet account. Withdrawal of funds is available to players with the <span className="silver">Silver</span> level
                        </div>
                    </div>
                )}

                <div className="page-title">My stats</div>

                {wallet.cashback.level === "bronze" && <MyLevels.Bronze deposits={wallet.cashback.deposits} />}
                {wallet.cashback.level === "silver" && <MyLevels.Silver deposits={wallet.cashback.deposits} />}
                {wallet.cashback.level === "gold" && <MyLevels.Gold deposits={wallet.cashback.deposits} />}
                {wallet.cashback.level === "platinum" && <MyLevels.Platinum deposits={wallet.cashback.deposits} />}
                {wallet.cashback.level === "diamond" && <MyLevels.Diamond deposits={wallet.cashback.deposits} />}

                {wallet.cashback.next_level_preset && (
                    <div className="block">
                        <div className="cashback_stats">
                            <div className="stat">
                                <div className="label">You need to make deposits in the amount of <span>${parseFloat((wallet.cashback.next_level_preset.amounts.from - wallet.cashback.deposits).toFixed(2))}</span> to increase your level</div>
                                <div className="value">
                                    <span className={wallet.cashback.next_level_preset.key}>{wallet.cashback.next_level_preset.key}</span>
                                </div>
                            </div>
                        </div>

                        <div className="progress">
                            <div className="progress-line">
                                <div className="line" style={{width: `${((wallet.cashback.deposits / wallet.cashback.next_level_preset.amounts.from)*100)}%`}}></div>
                            </div>
                            <div className="progress-info">
                                <div className="left">
                                    ${parseFloat(wallet.cashback.deposits.toFixed(2))}
                                </div>
                                <div className="right">
                                    ${parseFloat(wallet.cashback.next_level_preset.amounts.from.toFixed(2))}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div className="hiw">
                    <div className="title">How it works?</div>

                    <div className="hiw-block">
                        <div className="left">
                            💸
                        </div>
                        <div className="right">
                            Your VIP program level is calculated from the amount of deposits for the last <span>14 days</span>
                        </div>
                    </div>

                    <div className="hiw-block">
                        <div className="left">
                            🤑
                        </div>
                        <div className="right">
                            The higher your activity, the more <span>benefits</span> you get
                        </div>
                    </div>
                </div>

                <div className="page-title">VIP Levels</div>

                <div className="slider">
                    <Swiper 
                        modules={[Pagination]}
                        pagination={{
                            el: '.dots',
                            clickable: true,
                            renderBullet: (index, className) => {
                                return `<div class="dot ${className}" data-index="${index}"></div>`
                            }
                        }}
                        speed={500}
                        slidesPerGroup={1}
                        slidesPerView={1}>
                        <SwiperSlide><Levels.Bronze/></SwiperSlide>
                        <SwiperSlide><Levels.Silver/></SwiperSlide>
                        <SwiperSlide><Levels.Gold/></SwiperSlide>
                        <SwiperSlide><Levels.Platinum/></SwiperSlide>
                        <SwiperSlide><Levels.Diamond/></SwiperSlide>
                    </Swiper>

                    <div className="dots"></div>
                </div>
            </div>
        </>
    )
}